import React, { useState } from "react";
import "../../../styles/HelpModal.css";
import Label from "../../atoms/Label";

function DirectionsModal({ isOpen, onClose, section }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        {/* <div className="modal-header">
          <Label
            label="Help"
            fontSize="16px"
            fontWeight="700"
            color="#000000"
            textAlign="left"
            padding="0px"
          />
        </div> */}

        <div className="modal-content">
          {section === 2 ? (
            <div style={{ textAlign: "start" }}>
              <div>
                <p>
                  The questions in this section address a number of important
                  math skills.
                </p>
                <p>
                  Use of a calculator is permitted for all questions. A
                  reference sheet, calculator, and these directions can be
                  accessed throughout the tests.
                </p>
                <p>Unless otherwise indicated:</p>
                <ul>
                  <li>All variable and expressions represent real numbers.</li>
                  <li>Figures provided are drawn to scale.</li>
                  <li>All figures lie in a plane.</li>
                  <li>
                    The domain of a given function <i>f</i> is the set of all
                    real numbers <i>x</i> for which <i>f(x)</i> is a real number
                  </li>
                </ul>
                <p></p>
                <p>
                  For <b>multiple-choice questions</b>, solve each problem and
                  choose the correct answer from the choices provided. Each
                  multiple-choice question has a single correct answer.
                </p>
                <p>
                  For <b>student-produced response questions</b>, solve each
                  problem and enter your answer as described below.
                </p>
                <ul>
                  <li>
                    If you find <b>more than one correct answer</b>, enter only
                    one answer.
                  </li>
                  <li>
                    You can enter up to 5 characters for a <b>positive</b>{" "}
                    answer and up to 6 characters (including the negative sign)
                    for a <b>negative</b> answer.
                  </li>
                  <li>
                    If your answer is a <b>fraction</b> that doesn't fit in the
                    provided space, enter the decimal equivalent.
                  </li>
                  <li>
                    if your answer is a <b>decimal</b> that doesn't fit in the
                    provided space, enter it by truncating or rounding at the
                    fourth digit.
                  </li>
                  <li>
                    If your answer is a <b>mixed number</b> (such as 3 1/2),
                    enter it as an improper fraction (7/2) or its decimal
                    equivalent(3.5)
                  </li>
                  <li>
                    Don't enter <b>symbols</b> such as a percent sign, comma, or
                    dollar sign.
                  </li>
                </ul>
                <p></p>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    class="img-responsive"
                    id="math-ref-chart-img"
                    src="https://www.princetonreview.com/Content/Images/Dashboard/SAT/student-produced-reponses-chart.png"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="directions-modal-content">
              <p>
                The question in the section address are number of important
                reading and writing skills. Each question include one or more
                passages, which may include a table or a graph. Read each
                passage and question carefully, and then choose the best answer
                to the question based on the passage(s)
              </p>
              <p>
                All questions in these section are multiple-choice with four
                answer choices. Each question has a single best answer.
              </p>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="close-btn-large" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default DirectionsModal;
